import { Injectable } from '@angular/core';
import { RemoteConfigParameter } from '@nx-customer-apps/shared/enums';
import { RemoteConfigService } from './remote-config.service';

@Injectable({
    providedIn: 'root'
})
export class CreateReportUtilsService {
    constructor(private remoteConfigService: RemoteConfigService) {}

    public isDocumentationAvailable(): boolean {
        return !!this.remoteConfigService.config[RemoteConfigParameter.PdfConfiguratorDocumentationTabVisible];
    }
}
